<!--
 * @Description: 
 * @Date: 2020-07-27 11:25:02
-->
<template>
  <div class="comment" ref="comWrapper">
    <div
      class="cover"
      v-show="chooseFlag"
      @click="chooseFlag = false"
      @touchmove.prevent
    ></div>
    <div class="sBox" v-show="type < 4">
      <div class="comNum">
        <span class="indexCount">{{ type === 3 ? '提问区' : '全部评论' }}</span>
      </div>
    </div>
    <list
      v-bind="$data"
      defaultText="还没有任何评论，赶快发布吧"
      @click.native="clickList"
      :listData="forEachList"
    >
      <ul
        ref="listScroll"
        class="ulBox"
        @touchmove="preLoad"
        v-if="forEachList.length"
      >
        <li class="comConLi" v-for="(item, index) in forEachList" :key="index">
          <div class="disable-item" :key="index" v-if="item.isDisableUser">
            <div class="content">
              <img :src="require('@/assets/v-1.jpg')" alt />
              {{ item.nickName }}已被禁言
            </div>
          </div>
          <div v-else style="display: flex">
            <img
              :src="
                item.headPhoto ||
                  'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/defaultPhoto.png'
              "
              class="comUserPh"
            />
            <div class="comUserCon" @click="clickReplay(item)">
              <div class="comUserNZ">
                <span class="comUserName">{{ item.fullName }}</span>
                <span
                  class="comUserName"
                  style="
                    color: #fff;
                    border-radius: 8px;
                    background: #027cfa;
                    padding: 0 0.3rem;
                    margin-left: 0.2rem;
                  "
                  v-if="item.rank"
                >
                  {{ item.rank }}
                </span>
              </div>
              <div class="comTime">{{ item.createDt | transTime }}</div>

              <div class="comCT">
                <img
                  @click="
                    () => {
                      showImg = true;
                      showImgImg = item.commentContent;
                    }
                  "
                  v-if="item.msgType == 3"
                  style="width: 100%"
                  :src="item.commentContent"
                />
                <template v-else>
                  <span v-if="!item.beReplyUserName && !item.beReplyUserId">
                    {{
                      item.replyUserNickName
                        ? `回复@${item.replyUserNickName}：`
                        : ''
                    }}{{ item.commentContent }}
                  </span>
                </template>
              </div>
              <div
                v-if="item.replyUserNickName"
                style="
                  background: #e9e9e9;
                  padding: 0.1rem 0.2rem;
                  font-size: 0.32rem;
                  border-radius: 0.05rem;
                  margin-top: 0.2rem;
                "
              >
                回复
                <span style="color: rgba(54, 103, 236, 0.8)">
                  @{{ item.replyUserNickName }}
                </span>
                :{{ item.replyContent }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </list>

    <div class="footer">
      <div class="footer-input">
        <textarea
          type="text"
          ref="replyInput"
          :placeholder="placeholder"
          v-model.trim="replyValue"
          @keyup.enter="sendReply"
          @focus="onFocus"
          @blur="onBlur"
        />
        <!-- <img
          class="emoji"
          src="http://yiyang.oss-cn-beijing.aliyuncs.com/WEB/wx-master/images/face.png"
          @click="isUseEmoji"
        />-->
      </div>
      <img
        class="collection"
        v-if="type != 3"
        v-show="!focus && !replyValue.length"
        :src="[
          isCollection
            ? 'http://cdn.yxvzb.com/WEB/SaaS/images/0929_1417_c.png'
            : 'http://cdn.yxvzb.com/newWechat/image/%E6%94%B6%E8%97%8F@2x.png'
        ]"
        @click="collection"
      />
      <ul
        class="comment__living"
        v-show="!focus && !replyValue.length && type == 3"
      >
        <li>
          <img
            src="@/static/img/living/lw.png"
            alt
            @click.stop="showGift = true"
          />
        </li>
        <li>
          <img
            ref="zan"
            class="comment__heart"
            src="@/static/img/living/zan_no.png"
            @click="heartClickHandler(isZan)"
          />
        </li>
      </ul>
      <van-button
        class="send"
        v-show="focus || replyValue.length"
        :disabled="replyValue.length < 2"
        type="primary"
        @click="sendReply"
        color="#3667EC"
      >
        发送
      </van-button>
      <emoji
        v-model="isOpenEmoji"
        @sendFatherEmoji="getEmoji"
        @deleteFatherEmoji="deleteEmoji"
      ></emoji>
      <send-gift v-model="showGift" @send="sendGif"></send-gift>
    </div>
    <van-popup v-model="showImg">
      <img style="max-width: 9rem" :src="showImgImg" alt />
    </van-popup>
  </div>
</template>
<script>
import index from './comment';
export default index;
</script>
<style lang="less" scoped="">
@import './comment.less';
</style>
